export default __webpack_public_path__ + "static/media/violetPlus.0bbcef7d.svg";